import capitalize from 'lodash/capitalize';
import deburr from 'lodash/deburr';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import padStart from 'lodash/padStart';
import toLower from 'lodash/toLower';
import trim from 'lodash/trim';

const normalize = (str) => trim(deburr(str));

const normalizeIgnoreCase = (str) => {
  return toLower(normalize(str));
};

const booleanFromString = (value) => {
  // eslint-disable-next-line
  switch (value) {
    case 'true':
      value = true;
      break;
    case 'false':
      value = false;
      break;
  }

  return value;
};

const htmlStringIsEmpty = (content) => {
  // Attention to zero width space character (\u200b) within the paragraph (https://bit.ly/2FIaCBN)
  return !content || content === '<p>​</p>' || content === '<p><br></p>';
};

function rawText(content) {
  if (isNil(content)) {
    return '';
  }

  return content
    .replace(/\u200B/gi, '')
    .replace(/<[^>]+>|\u200B|\t|\n|\r|<\/(.*?)>|&nbsp/gi, '')
    .trim();
}

const isString = (value) =>
  Object.prototype.toString.call(value) === '[object String]';

const rawTextLength = (content = '') => {
  if (!content || !isString(content)) {
    return false;
  }

  return rawText(content).length;
};

const isBlank = (value) => isNil(value) || isEmpty(trim(value));

const encodeEntities = (content = '') =>
  content
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const stripPTag = (tag) => (tag ? `${tag}`.replace(/<\/?p[^>]*>/gi, '') : '');

const convertColumnNumberToAlphabetLetter = (rowNumber) => {
  const alphabetSize = 26;
  const charCodeA = 65;
  let letter = '';

  while (rowNumber > 0) {
    const rest = (rowNumber - 1) % alphabetSize;

    letter = String.fromCharCode(charCodeA + rest) + letter;
    rowNumber = parseInt((rowNumber - rest) / alphabetSize, 10);
  }

  return letter;
};

const createDjb2Hash = (str) => {
  const INITIAL_HASH_VALUE = 5381;
  const MULTIPLICATION_FACTOR = 33;
  const HEXADECIMAL_FACTOR = 16;
  let hash = INITIAL_HASH_VALUE;

  for (let i = 0; i < str.length; i++) {
    hash = hash * MULTIPLICATION_FACTOR + str.charCodeAt(i);
  }

  return hash.toString(HEXADECIMAL_FACTOR);
};

export {
  booleanFromString,
  htmlStringIsEmpty,
  normalize,
  normalizeIgnoreCase,
  toLower,
  trim,
  rawTextLength,
  rawText,
  isBlank,
  stripPTag,
  isString,
  padStart,
  capitalize,
  encodeEntities,
  convertColumnNumberToAlphabetLetter,
  createDjb2Hash
};
